import { DOCUMENT } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RequestBodyContextBuilder } from "@shared/builders/request-body-context.builder";
import { OfferCardComponent } from "@shared/components/offer-card/offer-card.component";
import { ResourcesLimitsDialogComponent } from "@shared/components/resources-limits-dialog/resources-limits-dialog.component";
import { ACCUEIL } from "@shared/constants/route.constants";
import { DistributorCode } from "@shared/enums/distributorCode.enum";
import { Member } from "@shared/models/member";
import { SafeHtmlPipe } from "@shared/pipes/safe-html.pipe";
import { ContextService } from "@shared/services/context.service";
import { MembersService } from "@shared/services/members.service";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-offers",
  standalone: true,
  imports: [OfferCardComponent, ButtonModule, TranslateModule, ResourcesLimitsDialogComponent, SafeHtmlPipe],
  templateUrl: "./offers.component.html",
  styleUrl: "./offers.component.scss",
})
export class OffersComponent implements OnInit {
  readonly PRODUCT_TYPE_PARIS = "paris";
  readonly PRODUCT_TYPE_TOURQUENOISE = "tourquenoise";
  readonly branchCode = "MRH";
  readonly createHcQuotationCode = "HC";
  readonly createHsQuotationCode = "HS";
  readonly createHpQuotationCode = "HP";
  readonly createHtQuotationCode = "HT";

  constructor(
    private readonly contextService: ContextService,
    private readonly membersService: MembersService
  ) {}

  private document = inject(DOCUMENT);

  homeLink = ACCUEIL;

  member: Member | undefined;

  resourcesLimitsDialogVisible = false;
  selectedProductType!: string;

  ngOnInit() {
    this.membersService.getMemberInformations().subscribe(data => {
      this.member = data;
    });
  }

  openResourcesLimitsDialog(productType?: string) {
    this.selectedProductType = productType ?? "";
    this.resourcesLimitsDialogVisible = true;
  }

  resourcesLimitsDialogClose() {
    this.resourcesLimitsDialogVisible = false;
  }

  createNewQuotation(productCode: string) {
    try {
      const requestBody = new RequestBodyContextBuilder()
        .setProduit(productCode)
        .setBranche(this.branchCode)
        .setCodeVendeur(DistributorCode.VY)
        .setEmail(this.member!.email)
        .build();

      this.contextService.createContext(requestBody).subscribe({
        next: redirectUrl => {
          this.document?.defaultView?.open(redirectUrl, "_blank");
        },
        error: error => {
          console.error("Erreur lors de la création du contexte", error);
        },
      });
    } catch (error) {
      console.error("Erreur lors de la construction du requestBody", error);
    }
  }
}
